// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;500);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._6Osb_5EoUH7xymJd02GM {
  border: unset;
  border-radius: 50%;
  width: 43px;
  height: 43px;
  background-color: #774dee;
  padding: 0 !important;
}
._6Osb_5EoUH7xymJd02GM:hover {
  background-color: #6439df;
}
._6Osb_5EoUH7xymJd02GM:active {
  background-color: #5b37c0;
}`, "",{"version":3,"sources":["webpack://./src/shared/auth/components/ProfileButton.module.scss","webpack://./src/editor/style/variables.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBCHO;EDIP,qBAAA;AAAF;AACE;EACE,yBCLS;ADMb;AACE;EACE,yBCPS;ADQb","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profileButton": `_6Osb_5EoUH7xymJd02GM`
};
export default ___CSS_LOADER_EXPORT___;
